import { Injectable } from '@angular/core';
import { State, Cipher } from '../shared/types';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ConfigApiService } from './config-api.service';

let aesjs = require('aes-js');
let forge = require('node-forge');

@Injectable({
  providedIn: 'root',
})
export class PersistanceService {
  private identifier: string = environment.StateIdentifier;

  constructor(
    private http: HttpClient,
    private configApiService: ConfigApiService
  ) {}

  persistState(state: State, commit: boolean, studyFinished: boolean) {
    sessionStorage.setItem(this.identifier, JSON.stringify(state));

    if (commit == true) {
      //transfer results to the backend
      this.transferState(state, studyFinished);
    }
  }
  
  clearSessionStorage() {
    sessionStorage.clear();
  }

  private transferState(state: State, studyFinished: boolean) {
    try {
      const url: string = `${environment.backendURL}${environment.endpointStoreResults}`;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };

      const cipher: Cipher = this.encryptState(state);

      const transferObject = {
        userId: this.configApiService.getParams().user,
        projectId: this.configApiService.getParams().project,
        encryptedResults: cipher.encryptedHex,
        encryptedAESkey: cipher.encryptedKey,
        hasFinished: studyFinished,
      };

      this.http.post(url, transferObject, httpOptions).subscribe((res) => {
        console.log('Results have been sent to the backend');
      });
    } catch (error) {
      console.error(
        'An error occured while transfering the study results to the backend'
      );
      console.error(error);
    }
  }

  private encryptState(state: State): Cipher {
    let key = this.makeid(16); // [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16 ];

    // Convert text to bytes
    let textBytes = aesjs.utils.utf8.toBytes(JSON.stringify(state));

    // The counter is optional, and if omitted will begin at 1
    let aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    let encryptedBytes = aesCtr.encrypt(textBytes);

    let encryptedKey = this.encryptKey(key.join(','));

    // To print or store the binary data, you may convert it to hex
    let encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);

    return { encryptedHex, encryptedKey };
  }

  private makeid(length: number): any {
    // pseudorandom generator for key/IV
    let id = [];
    for (let i = 0; i < length; i++) {
      id.push(Math.floor(Math.random() * 256));
    }
    return id;
  }

  private encryptKey(key: string): string {
    const PUBLIC_KEY = environment.encryptionPublicKey;

    var publicKey = forge.pki.publicKeyFromPem(PUBLIC_KEY);

    var encrypted = publicKey.encrypt(key, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: forge.mgf1.create(),
    });
    //publicKey.encrypt(secretMessage);

    var encrypted_key = forge.util.encode64(encrypted);

    return encrypted_key;
  }
}
